export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrowHead.a01ed1ad.svg","height":6,"width":8,"blurWidth":0,"blurHeight":0};